import Vue from 'vue'
import App from './App.vue'
import 'tailwindcss/tailwind.css'
import VModal from 'vue-js-modal'
import VueToastr from 'vue-toastr'
import VueMask from 'v-mask'

Vue.config.productionTip = false
Vue.use(VModal)
Vue.use(VueToastr)
Vue.use(VueMask)

new Vue({
  render: h => h(App),
}).$mount('#app')
